<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-xytsz__studentTaskDecoration">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('xytsz:studentTaskDecoration:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('xytsz:studentTaskDecoration:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键" header-align="center" align="center"></el-table-column>
        <el-table-column prop="studentId" label="学生id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="studentName" label="学生名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="decorationId" label="奖章id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="decorationName" label="奖章名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isDecoration" label="是否获得奖章" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建者" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updater" label="更新者" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="schoolId" label="学校id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="termTableId" label="学期争章表id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="termId" label="学期id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="classId" label="班级id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isView" label="家长是否已经查看" header-align="center" align="center"></el-table-column>
        <el-table-column prop="decorationTime" label="奖章获取时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="isLike" label="0为未点赞 1为点赞" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('xytsz:studentTaskDecoration:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('xytsz:studentTaskDecoration:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './studenttaskdecoration-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/xytsz/studentTaskDecoration/page',
        getDataListIsPage: true,
        exportURL: '/xytsz/studentTaskDecoration/export',
        deleteURL: '/xytsz/studentTaskDecoration',
        deleteIsBatch: true
      },
      dataForm: {
      }
    }
  },
  watch: {
  },
  components: {
    AddOrUpdate
  }
}
</script>
